import './image.scss';

import Skeleton from 'antd/lib/skeleton';

import brokenImage from '@/media/images/broken-image.png';

import { useImageSrc } from './hooks';

interface IProps extends React.HTMLProps<HTMLImageElement> {
  fallbackSrc?: string;
  classes?: {
    root?: string;
    loading?: string;
  };
  loading?: 'lazy' | 'eager';
  loadingFromParent?: boolean;
}

const Img: React.FC<IProps> = ({
  fallbackSrc,
  classes,
  loadingFromParent = false,
  ...props
}) => {
  const {
    loading,
    error,
    src: currentSrc
  } = useImageSrc(props.src, loadingFromParent);

  const rootClassName = ['image-component', classes?.root]
    .filter(Boolean)
    .join(' ');

  const imageClassName = [
    'image-component__img',
    props.className,
    loading && 'image-component__img--loading',
    error && 'image-component__img--broken'
  ]
    .filter(Boolean)
    .join(' ');

  const skeletonClassName = ['image-component__skeleton', classes?.loading]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClassName}>
      {!loading ? (
        (currentSrc || error) && (
          <img
            {...props}
            src={currentSrc && !error ? currentSrc : fallbackSrc || brokenImage}
            className={imageClassName}
          />
        )
      ) : (
        <Skeleton.Image className={skeletonClassName} active />
      )}
    </div>
  );
};

export default Img;
